const createSumoLogger = path => (params) => {
  const SUMO_DOMAIN = window.parent.STV.environment === 'production'
    ? 'sumologic.stv.tv'
    : 'sumologic.stvqa.tv'

  const endpoint = `https://${SUMO_DOMAIN}${path}`

  const headers = new Headers()
  headers.append('Content-Type', 'application/json')

  fetch(endpoint, {
    headers,
    method: 'POST',
    withCredentials: false,
    body: JSON.stringify(params),
  }).then((response) => {
    if (!response.ok) {
      throw new Error(`Sumo request failed: ${response.status}`)
    }
  }).catch(err => console.error('QoS Error: Unable send data to sumo', err)) // eslint-disable-line no-console
}

export default {
  reportAdError: createSumoLogger('/errors/advert'),
  reportVideoError: createSumoLogger('/errors/video'),
  reportAdQoS: createSumoLogger('/logs/advert'),
  reportVideoQoS: createSumoLogger('/logs/video'),
}

export const createPlayerStateGetter = ({
  player,
  type = 'VOD',
}) => () => {
  if (type === 'VOD') {
    try {
      const { vhs } = player.tech({ IWillNotUseThisInPlugins: true })

      const videoBitRate = vhs
        ? vhs.throughput / 1024 / 8 // in kb/s
        : null

      const width = player.el_.offsetWidth
      const height = player.el_.offsetHeight

      const qosDroppedFrames = player.getVideoPlaybackQuality && player
        .getVideoPlaybackQuality()
        .droppedVideoFrames

      return {
        type,
        videoUrl: player.currentSrc(),
        videoCurrentTime: player.currentTime(),
        videoBitRate,
        qosDroppedFrames,
        videoResolution: `${width}x${height}`,
        videoDuration: player.mediainfo && player.mediainfo.duration,
      }
    } catch (e) {
      console.log('QoS: Error recording VOD player state', e) // eslint-disable-line no-console
      return {}
    }
  }

  if (type === 'LIVE') {
    try {
      const height = player.videoHeight
      const width = player.videoWidth
      const now = new Date()

      return {
        type,
        videoUrl: player.src,
        videoCurrentTime: player.currentTime,
        videoStartTime: now.toISOString(),
        videoResolution: `${width}x${height}`,
        videoDuration: 0,
      }
    } catch (e) {
      console.log('QoS: Error recording LIVE player state', e) // eslint-disable-line no-console
      return {}
    }
  }

  return { type: 'undefined' }
}
